import React from 'react';
import styles from './Splatanie.css';
import splatanieImg from '../../../assets/splatanie.jpg';
import spacer from '../../../assets/spacer.png';
import CallToActionBtn from "../../CallToActionBtn/CallToActionBtn";

const text = {
    "subtitle": "Korzenie zła sięgają głęboko",
    "desc1": "Pierwsza część cyklu powieści kryminalno-okultystycznych z Jakubem Kempnerem, policyjnym śledczym. Zdegradowany i przeniesiony do Wrocławia, zostaje przydzielony do rutynowej sprawy samobójstwa. To, co miało być standardowym wypełnieniem dokumentacji, szybko przeradza się w ciąg niespodziewanych zdarzeń",
    "desc2": "Demoniczny byt gnieżdżący się w okolicy ma szansę tylko raz na kilkadziesiąt lat wypełnić rytuał zapoczątkowany ponad dwa wieki temu."
};

const Splatanie = (props) => (
    <div className={styles.mainDiv}>
        <img src={splatanieImg} className={styles.mainImg} alt="Splątanie"/>
        <p className={styles.subtitle}>{text["subtitle"]}</p>
        <img src={spacer} className={styles.spacer} alt="spacer"/>
        <p className={styles.text}>{text["desc1"]}</p>
        <img src={spacer} className={styles.spacer} alt="spacer"/>
        <p className={styles.text}>{text["desc2"]}</p>
        <img src={spacer} className={styles.spacer} alt="spacer"/>
        <CallToActionBtn />
    </div>
);

export default Splatanie;


// WEBPACK FOOTER //
// ./src/components/Mobile/Splatanie/Splatanie.js